import { render, staticRenderFns } from "./PostDigitalReply.vue?vue&type=template&id=1ae3817a&"
import script from "./PostDigitalReply.vue?vue&type=script&lang=js&"
export * from "./PostDigitalReply.vue?vue&type=script&lang=js&"
import style0 from "./PostDigitalReply.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports